// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';
import * as ROLES from '../roles';

// constant
const icons = {
    IconDashboard,
    IconDeviceAnalytics
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',
    type: 'group',
    title: <FormattedMessage id="general" />,
    roles: [ROLES.ADMIN, ROLES.AUCTION_HOUSE, ROLES.CUSTOMER, ROLES.SHIPPER],
    children: [
        {
            id: 'dashboard',
            title: <FormattedMessage id="dashboard" />,
            type: 'item',
            url: '/dashboard',
            icon: icons.IconDashboard,
            breadcrumbs: false,
            roles: [ROLES.ADMIN, ROLES.AUCTION_HOUSE, ROLES.CUSTOMER, ROLES.SHIPPER]
        }
    ]
};

export default dashboard;
